exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".vm-content .parent-section .leftIcon {\n  float: left;\n  margin: 0 10px; }\n\n.vm-content .parent-section .details {\n  float: left; }\n\n.vm-content .vm-dps-section {\n  border-top: 1px solid #eee;\n  border-bottom: 1px solid #eee;\n  margin: 15px 0 0 0;\n  padding: 10px 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vc/manage/virtual-machine/virtual-machine-details-vc.scss
// module id = Pa44
// module chunks = 0